import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ManageDevelopers = lazy(() =>
  import("@scenes/PermissionSettings/components/ManageDevelopers").then((module) => ({
    default: module.ManageDevelopers,
  }))
);

export const permissionSettingsCompanyUsersNRO: NavigationRoutingObject = {
  Component: ManageDevelopers,
  componentFeatureFlippers: ["unified_permission_settings_page"],
  noKnockoutFallback: true,
  section: "settings",
  // TODO (CLIP-2618) Rename this NRO heading to User Management. This is labeled Permission Settings so that we retain
  // backwards compatibility of the name in the Sidebar.
  heading: (t: I18nT<"dashboard-navigation">) => t("permission-settings", "Permission Settings"),
  getDeveloperNavigationAllowed: () => {
    // TODO (CLIP-2617): Fill this in, matching companyUsersNRO
    return true;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/company_settings/permission_settings/company_users/:appGroupId",
};
